module.exports = __webpack_public_path__ + "img/affect-sidebar.29de953c.svg";